import React, {useEffect, useState} from "react";

import axios, {formUrlEncodedHeaders} from "config/axiosConfig";
import dateFormat from "dateformat";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate, formatDateParam} from "../../../../util/helpers";

const nowYear = () => {
    const now = new Date();
    return now.getFullYear();
}

function List() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    let initYears = [];
    for (let i = 2024; i <= nowYear(); i++) {
        initYears.push(i);
    }
    initYears = initYears.reverse();

    const date = new Date();
    let month = date.getMonth() + 1;

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const paramYear = queryParams.get("year");
    const paramMembership = queryParams.get("membership");

    const page = searchParams.get('page') || "1";
    const year = searchParams.get('year') || nowYear();
    const membership = searchParams.get('membership') || "BUSINESS";

    const requestSearch = () => {
        const uri = `/admin/biz/expected-income-taxes?page=${page}&year=${year}&membership=${membership}`;
        axios.get(uri)
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    };

    const deleteIncomeTax = (id) => {
        if (id === null) { return; }
        if(window.confirm("삭제하시겠습니까?")) {
            axios.delete(`/admin/biz/expected-income-taxes/${id}`)
                .then((res) => {
                    window.location.reload();
                });
        }
    };

    const updateVisible = (id, bizId, visible) => {
        if (id === null) { return; }
        const newContents = contents.map((contentItem, i) =>
            contentItem.bizId === bizId
                ? { ...contentItem, visible: visible }
                : contentItem
        );
        setContents(newContents);

        let params = {visible: visible};
        axios.put(`/admin/biz/expected-income-taxes/${id}/visible`, params, formUrlEncodedHeaders)
            .then((res) => {

            })
            .catch((err) => {
                const newContents = contents.map((contentItem, i) =>
                    contentItem.bizId === bizId
                        ? { ...contentItem, visible: !visible }
                        : contentItem
                );
                setContents(newContents);
            });
    };

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">예상종합소득세 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <button type="submit" className="btn btn-info float-right" style={{width: '80px', marginRight: '10px'}}
                                                    onClick={ () => {
                                                        setPage(1);
                                                        requestSearch();
                                                    }}>
                                                검색
                                            </button>

                                            <select className="form-control float-right"
                                                    style={{width: '200px', marginRight: '10px'}}
                                                    onChange={ (e) => {
                                                        searchParams.set('membership', e.target.value);
                                                        setSearchParams(searchParams)
                                                    }}
                                                    value={membership}>
                                                <option value="BUSINESS">BUSINESS</option>
                                                <option value="BASIC">BASIC</option>
                                                <option value="">ALL</option>
                                            </select>
                                            <select className="form-control float-right" style={{width: '200px', marginRight: '10px'}}
                                                    onChange={ (e) => {
                                                        searchParams.set('year', e.target.value);
                                                        setSearchParams(searchParams)
                                                    }}
                                                    value={year}>
                                                {
                                                    initYears.map(year => {
                                                        return (
                                                            <option value={year} key={year}>{year}년</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>bizId</th>
                                                    <th>사업자명</th>
                                                    <th>사업자번호</th>
                                                    <th>멤버십</th>
                                                    <th>보고서</th>
                                                    <th>생성일</th>
                                                    <th>노출여부</th>
                                                    <th>상세</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents.map((item, index) => {
                                                        return (
                                                            <tr key={item.bizId}>
                                                                <td>{item.bizId}</td>
                                                                <td>{item.bizName}</td>
                                                                <td>{formatBusinessNumber(item.bizNo)}</td>
                                                                <td>{item.bizMembershipType}</td>
                                                                <td>
                                                                    {
                                                                        item.expectedYear === null
                                                                        ? <span style={{color: 'orangered'}}>미생성</span>
                                                                        : <span>{item.expectedYear}년 예상 종합소득세</span>
                                                                    }
                                                                </td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                                <td width="110px">
                                                                    <div className="form-group row">
                                                                        <div className="custom-control custom-switch custom-switch-on-success">
                                                                            <input type="checkbox"
                                                                                   className="custom-control-input"
                                                                                   id={"customSwitch" + index}
                                                                                   checked={item.visible}
                                                                                   onChange={ e => {
                                                                                       updateVisible(item.incomeTaxId, item.bizId, e.target.checked);
                                                                                   }}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor={"customSwitch" + index}>
                                                                                {
                                                                                    item.visible
                                                                                        ? <span>노출(ON)</span>
                                                                                        : <span>노출(OFF)</span>
                                                                                }
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-outline-danger btn-sm"
                                                                        onClick={() => deleteIncomeTax(item.incomeTaxId)}>
                                                                        삭제
                                                                    </button>
                                                                    <Link className="btn-sm" to={`/page/biz/expected/income/edit?bizId=${item.bizId}&year=${year}&incomeTaxId=${item.incomeTaxId || ""}`}>
                                                                        <button type="button" className="btn btn-outline-primary btn-sm">
                                                                            보기
                                                                        </button>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>
                </div>
            </div>
        </div>
    );
}

export default List;
